import { InfoItem, SectionTitle } from "@/components/molecules";
import { PageContainer } from "@/components/organisms";
import {capitalizeFirst, formatDateToYMD} from '@/helpers/shadcn/utils'

const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const DisplayRewards = ({rewardsDetails}) => {
  const rewardsData = [
    {label: 'Processed Status', value: capitalizeFirst(rewardsDetails?.processedStatus)},
    {label: 'Rewards Processed Date', value: formatDateToYMD(rewardsDetails?.rewardsProcessedDate)},
    {label: 'Dollar Spend Processed Date', value: formatDateToYMD(rewardsDetails?.dollarSpendProcessedDate)},
    {label: 'Dollars Spend', value: rewardsDetails?.dollarSpend},
    {label: 'Dollar Spend Calculated', value: rewardsDetails?.dollarSpendCalculated},
  ]

  return (
    <>
      {/* Rewards Section */}
      <div className="order-overview">
        <div className="sc-border grid pl-4">
          <Section id="rewards" title="Rewards" />
        </div>
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          {rewardsData.map(item => (
            <InfoItem key={item.label} label={item.label} value={item.value} />
          ))}
        </div>
        <div className="grid pb-6 pl-4">
          <InfoItem label="Processing Notes" value={rewardsDetails?.processingNotes} />
        </div>
      </div>
    </>
  )
}

const OfflineOrderRewards = ({ rewardsDetails }) => {
  return (
    <PageContainer>
      <DisplayRewards rewardsDetails={rewardsDetails} />
    </PageContainer>
  );
};

export default OfflineOrderRewards;